/**
 * Supported exchange codes — mirrors trading-service ExchangeCode
 */
export type ExchangeCode =
  | "binance"
  | "bybit"
  | "gate"
  | "kucoin"
  | "asterdex"
  | "hyperliquid";

export const SUPPORTED_EXCHANGES: ExchangeCode[] = [
  "binance",
  "bybit",
  "gate",
  "kucoin",
  "asterdex",
  "hyperliquid",
];

/** Result of checking token availability across every supported exchange at once. */
export type ExchangeAvailabilityMap = Record<ExchangeCode, TokenAvailability>;

/**
 * Token availability check result
 */
export interface TokenAvailability {
  symbol: string;
  available: boolean;
  status: string;
  spotAvailable?: boolean;
}

/**
 * Contract trading information
 */
export interface ContractInfo {
  symbol: string;
  exchangeCode: string;
  tickSize: number;
  minPrice: number;
  maxPrice: number;
  minQty: number;
  maxQty: number;
  maxLeverage: number;
  stepSize: number;
  minNotional: number;
  /** Amount of base represented by one contract */
  quantoMultiplier?: number;
  /** Current mark price for the contract */
  markPrice?: number;
  /** USD value of one contract (quantoMultiplier * markPrice) */
  contractValue?: number;
  /** Asset index (Hyperliquid only) */
  assetIndex?: number;
  /** Size decimals for quantity formatting (Hyperliquid only) */
  szDecimals?: number;
}
